import { Injectable } from "@angular/core";
import { AbstractParser } from "../../parser";
import { CompanyFinancialReportsPageableResult } from "src/app/ui/models/domains/pbm/companies/company-financial-reports-pageable-result.model";
import { parseCompanyFinancialReportsPageableResult } from "./company-parse-functions";

@Injectable()
export class CompanyFinancialReportsParser extends AbstractParser<CompanyFinancialReportsPageableResult> {
  parse(payload: any): CompanyFinancialReportsPageableResult {
    return parseCompanyFinancialReportsPageableResult(payload);
  }
}
